// CacheKey d28dd805bfb9177b3e003e7f3b819135
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  uk: {
    date: {
      abbr_month_names: [
        null,
        "січ",
        "лют",
        "бер",
        "кві",
        "тра",
        "чер",
        "лип",
        "сер",
        "вер",
        "жов",
        "лис",
        "гру"
      ],
      month_names: [
        null,
        "січня",
        "лютого",
        "березня",
        "квітня",
        "травня",
        "червня",
        "липня",
        "серпня",
        "вересня",
        "жовтня",
        "листопада",
        "грудня"
      ],
      order: [
        "day",
        "month",
        "year"
      ],
      day_names: [
        "неділя",
        "понеділок",
        "вівторок",
        "середа",
        "четвер",
        "пʼятниця",
        "субота"
      ],
      formats: {
        default: "%d.%m.%Y",
        long: "%d %B %Y",
        short: "%d %b"
      }
    },
    time: {
      am: "AM",
      pm: "PM"
    },
    time_zones: {
      est: "Східний час",
      edt: "Східний час",
      cst: "Центральний час",
      cdt: "Центральний час",
      mst: "Гірський час",
      mdt: "Гірський час",
      pst: "Тихоокеанський час",
      pdt: "Тихоокеанський час",
      hst: "Час Гаваїв–Алеутських островів",
      hdt: "Час Гаваїв–Алеутських островів",
      akst: "Час Аляски",
      akdt: "Час Аляски"
    }
  }
}

